import React from "react";
import { Col, FormGroup, Table, Button } from "reactstrap";
import DoubleScrollbar from "../../node_modules/react-double-scrollbar";

import TooltipItem from "./TooltipItem";

class TableGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: 20,
      pagsel: 1,
      filto: null,
      textSearch: null,
    };
  }

  componentDidMount() {
    const { rowsOfpaper } = this.props;
    if (rowsOfpaper) {
      this.setState({ pagination: rowsOfpaper });
    }
  }

  headers = () => {
    const { detalle, header } = this.props;
    if (detalle) {
      const { headers } = detalle;
      let renderHead = header ? header : headers;

      return renderHead.map((h, index) => {
        var admn = h.visible ? "" : "Hide_All";

        let width = null;
        if (h.type === "buttons") {
          width = h.buttons.length * 60;
        }
        return (
          <th
            key={index}
            className={`tr_head ${admn}`}
            onClick={(e) => {}}
            etiqueta={h.field}
            style={{
              width: width ? width : "auto",
            }}
          >
            {h.title}
          </th>
        );
      });
    }

    return null;
  };

  body = () => {
    const { detalle, filterVisibles } = this.props;
    const { pagination, pagsel, filto, textSearch } = this.state;
    if (detalle) {
      const { data } = detalle;
      return data
        .filter((item) => {
          if (filterVisibles) {
            if (item.visible) {
              return item;
            }
          } else {
            return item;
          }
        })
        .filter((item) => {
          if (filto && textSearch) {
            let expresion = item[filto]
              .toLowerCase()
              .indexOf(textSearch.toLowerCase());
            if (expresion > -1 && textSearch.length > 3) {
              return item;
            }
          } else {
            return item;
          }
        })
        .map((v, i) => {
          let pagination_ = i / pagination + 1;
          pagination_ = parseInt(pagination_, 10);
          return (
            <tr
              key={i}
              className={"tr_cnt" + (pagination_ !== pagsel ? " Hide_pag" : "")}
              pag={pagination_}
              candidato={pagination_}
            >
              {this.generaColumnas(v)}
            </tr>
          );
        });
    }
    return null;
  };

  generaColumnas = (v) => {
    const { detalle, header } = this.props;
    const { headers } = detalle;
    let renderHead = header ? header : headers;

    return renderHead.map((h, index) => {
      var admn = h.visible ? "" : "Hide_All";
      let type = h.type;
      if (type === "checkbox") {
        return (
          <td key={index} className={`${h.field} ${admn}`}>
            <input
              type="checkbox"
              defaultChecked={v[h.field]}
              disabled={true}
            />
          </td>
        );
      } else if (type === "buttons") {
        if (h.buttons) {
          return (
            <td key={index} className={`${h.field} ${admn}`}>
              {this.generaButtons(h.buttons, v)}
            </td>
          );
        }
        return null;
      } else {
        return (
          <td key={index} className={`${h.field} ${admn}`}>
            {v[h.field]}
          </td>
        );
      }
    });
  };

  generaButtons = (buttons, parametros) => {
    const { onEdit, onDelete, onConfig } = this.props;

    return buttons.map((item, index) => {
      let urlImg = "";
      let callback = null;
      let visible = true;
      if (item.action === "edit") {
        urlImg = `${process.env.PUBLIC_URL}/images/edit.png`;
        callback = onEdit;
      } else if (item.action === "delete") {
        urlImg = `${process.env.PUBLIC_URL}/images/delete.png`;
        callback = onDelete;
        visible = parametros.idEstatus;
      } else if (item.action === "config") {
        if (item.pathIcon) {
          urlImg = `${process.env.PUBLIC_URL}${item.pathIcon}`;
        } else {
          urlImg = `${process.env.PUBLIC_URL}/images/preparar.png`;
        }
        callback = onConfig;
        visible = parametros.idEstatus;
      }
      if (visible) {
        return (
          <>
            <Button
              style={{ backgroundColor: "transparent", border: "none" }}
              onClick={() => {
                if (callback) {
                  callback(parametros);
                }
              }}
              key={index}
              id={`tol_${index}_${item.action}`}
            >
              <img src={urlImg} style={{ width: 25 }} alt="" />
            </Button>
            <TooltipItem
              text={item.text}
              target={`tol_${index}_${item.action}`}
            />
          </>
        );
      }
    });
  };

  generaPaginacion() {
    const { detalle } = this.props;
    const { pagination } = this.state;
    if (detalle) {
      const { data } = detalle;

      var a = [],
        len = data.length / pagination + 1;

      for (var i = 1; i <= len; i++) {
        a.push(
          <Button
            key={i - 1}
            className="btn_paginacion"
            onClick={(e) => this.goPag(e)}
            id={"btn_pag_" + i}
          >
            {i}
          </Button>
        );
      }
      return a;
    }
  }

  goPag(e) {
    var elm = e.target,
      val = elm.innerText,
      btns = document.querySelectorAll(".btn_paginacion");
    btns.forEach(function (b) {
      b.classList.remove("btn_pag_sel");
    });
    elm.classList.add("btn_pag_sel");
    this.setState({ pagsel: parseInt(val, 10) });
  }

  generaFiltros = () => {
    const { detalle, header } = this.props;
    const { headers } = detalle;
    let renderHead = header ? header : headers;

    let heads = renderHead.filter((item) => item.visible === true);
    return heads.map((f, index) => {
      if (f.filter) {
        return (
          <th key={index}>
            <input
              className="inp_Fltrs"
              key={index}
              idfiltro={f.field}
              onChange={(e) => this.aplicaFiltros(e)}
              placeholder={"Filtrar por " + f.title + "..."}
            />
          </th>
        );
      } else {
        return <th key={index}></th>;
      }
    });
  };

  aplicaFiltros(e) {
    let filto = e.target.attributes.getNamedItem("idfiltro").value;
    let value = e.target.value;
    if (value.length > 3) {
      this.setState({ filto: filto, textSearch: value });
    } else if (value.length === 0) {
      this.setState({ textSearch: null });
    }
  }

  render() {
    const { detalle, cssStyles } = this.props;
    if (detalle === undefined || detalle === null || detalle.length === 0) {
      return <h3>No hay información</h3>;
    }
    return (
      <div style={cssStyles}>
        <FormGroup className="dv_Mnj_Grid" row>
          <Col className="dv_pgns" sm={9} md={9} lg={9}>
            {this.generaPaginacion()}
          </Col>
          <Col sm={3} md={3} lg={3}>
            <label htmlFor="cmb_pag">Registros por página ...</label>
            <select
              id="cmb_pag"
              className="sel_pag"
              onChange={(e) => {
                this.setState({ pagination: parseInt(e.target.value) });
              }}
            >
              <option>10</option>
              <option>20</option>
              <option>30</option>
              <option>50</option>
              <option>100</option>
            </select>
          </Col>
        </FormGroup>
        <DoubleScrollbar>
          <Table id="tbl_spcl" striped bordered responsive>
            <thead>
              <tr>{this.headers()}</tr>
            </thead>
            <tbody>
              <tr className="tr_fltrs">{this.generaFiltros()}</tr>
              {this.body()}
            </tbody>
          </Table>
        </DoubleScrollbar>
      </div>
    );
  }
}

export default TableGrid;
